import { CapabilitiesT } from "src/hooks/useCapabilities/types";

export const canAccessSettingsPage = (capabilities: CapabilitiesT) =>
  capabilities.usersPermissions.canAccess ||
  capabilities.connections.canAccess ||
  capabilities.apiKeys.canAccess;
